import { Navigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  const isGuest = localStorage.getItem('guestMode') === 'true';

  if (loading) return <p>Loading...</p>;
  if (!user && !isGuest) return <Navigate to="/login" />;

  return children;
};

export default ProtectedRoute;
